import { render, staticRenderFns } from "./ContactsLightList.vue?vue&type=template&id=5eb960c8&"
import script from "./ContactsLightList.vue?vue&type=script&lang=js&"
export * from "./ContactsLightList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports